import { ComponentsTypeEnum } from './constant'
import {
  PreviewImageBanner,
  PreviewTitle,
  PreviewTextNav,
  PreviewSubtitle,
  PreviewImageCard,
  PreviewResourceType,
  PreviewPriceShow,
  PreviewGuideApply,
  PreviewRichShow,
  PreviewExperienceTemplate
} from '@dqyun/ui-ssr'

import previewConsult from './preview/consult.vue'
import couponContent from './preview/couponContent.vue'

export const ShowComponentMap = {
  [ComponentsTypeEnum.PICTURE_BANNER]: PreviewImageBanner,
  [ComponentsTypeEnum.PICTURE_NAV]: PreviewTextNav,
  [ComponentsTypeEnum.RICH_TXT]: PreviewRichShow,
  [ComponentsTypeEnum.TITLE]: PreviewTitle,
  [ComponentsTypeEnum.CONTENT]: PreviewSubtitle,
  [ComponentsTypeEnum.PICTURE]: PreviewImageCard,
  [ComponentsTypeEnum.PRODUCT_COUNT]: PreviewPriceShow,
  [ComponentsTypeEnum.RESOURCE_TYPE]: PreviewResourceType,
  [ComponentsTypeEnum.GUIDE_APPLY]: PreviewGuideApply,
  [ComponentsTypeEnum.CONSULT]: previewConsult,
  [ComponentsTypeEnum.EXP_TEMPLATE]: PreviewExperienceTemplate,
  [ComponentsTypeEnum.COUPON]: couponContent
}
